import { render, staticRenderFns } from "./index.vue?vue&type=template&id=089ef8a2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=089ef8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089ef8a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('089ef8a2')) {
      api.createRecord('089ef8a2', component.options)
    } else {
      api.reload('089ef8a2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=089ef8a2&scoped=true&", function () {
      api.rerender('089ef8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/AppBanner/index.vue"
export default component.exports